import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LeadScanPrimerGrid } from "../../components/grids/LeadScanGrid/LeadScanPrimerGrid";

const queryClient = new QueryClient();

export class LeadScanPrimerGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <LeadScanPrimerGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
} 